import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementHistoryList extends Layout {
    searchpanelSettlementHistory: SearchPanel;
    sourceDrsSettleHist: DataSource;
    tableSettlements: Table;
    textboxCheckNumberSearch: Textbox;
    textboxExternalInvoiceno: Textbox;
    textboxOrderId: Textbox;
    textboxPayDateSearch: Textbox;
    textboxPayeeIdSearch: Textbox;
    textboxVoidDateSearch: Textbox;
}
